import VDropdown from './VDropdown.vue';

export { VDropdown };
export default VDropdown;
